<template>
  <div v-if="loginFormDetail">
     <VForm   class="mb-5" @submit.prevent="loginForm" >
            <div class="d-flex justify-center align-center">
              <VCard class="popupform" style="width: 100% !important">
                <div class="d-flex flex-wrap justify-content-between">
                <div @click=" sendToParent()">
                  <v-btn  
                  color="#1f1f45">
                  <v-icon>mdi-arrow-left</v-icon>
                </v-btn>
                </div>
<div>
        <v-btn    @click="toggleView('registerFormDetail')" class="but-color" >
        register</v-btn>
        </div>

                </div>
                <div class="popupform_row row mt-2 align-items-center">
                  
                  <div class="col-md-4 px-2 py-1">
                    <label class="label-title">Email</label>

                    <v-text-field
                      class="login-form551"
                      v-model="loginDetails.email"
                      required
                      :rules="[requiredValidator, emailValidator]"
                      prepend-inner-icon="mdi-email"
                      variant="outlined"
                    ></v-text-field>
                  </div>
                  <div class="col-md-4 px-2 py-1">
                    <label class="label-title">Password</label>

                  <v-text-field
  v-model="loginDetails.password"
  class="login-form551"
  :type="showPassword ? 'text' : 'password'"
  required
  :rules="[
    v => !!v || 'Password is required'
  ]"
  :prepend-inner-icon="showPassword ? 'mdi-eye-off' : 'mdi-eye'"
  @click:prepend-inner="showPassword = !showPassword"
  variant="outlined"
/>

                  </div>
                  <div class="col-md-4 px-2 py-1" >
                      <div>
                        <VBtn
                          width="50%"
                          class="but-color"
                          type="submit"
                          :disabled="!loginformValidation"
                          block
                        
                        >
                          <VProgressCircular
                            color="white"
                            v-if="goLoader"
                            indeterminate
                          />
                          {{ !goLoader ? "Submit" : "" }}
                        </VBtn>
                      </div>
                    </div>

                  <!-- <VCol cols="2" /> -->
                </div>
        

              </VCard>
            </div>
          </VForm>
  </div>
  <div v-if="registerFormDetail">
    <registerForm  @updateformValue="getPopupData"  @updateValue="getChildValue" />
  </div>
<v-dialog v-model="getEmailRes" persistent max-width="500">
  <v-card class="p-1 text-center"  >
    <div class="text-right">
      <v-icon
        color="red"
        @click="getEmailRes = false"
        class="cursor-pointer"
      >
        mdi-close-circle
      </v-icon>
    </div>

    <div class=" mt-1 p-3">
      <h5>Invalid Email or Password</h5>
      
    </div>
  </v-card>
</v-dialog>

</template>

<script >
import registerForm from "@/components/registerForm.vue"
export default{
  props:{
    loginMsg: {
      
      type: Array,
      required: true
    }
  },
     components: {
        registerForm
     },
    data (){
    return{
         loginDetails:{
email:"",
password:""
      },
      goLoader: false,
      getEmailRes:false,
      shipId:"",
      showPassword:false,
      msgError:"",
      registerFormDetail:false,
    loginFormDetail:true,
    loginerrormsg:true,
      
    }
},
watch: {
  loginMsg(newVal) {
    if(newVal){
      this.getEmailRes=true
      this.goLoader=false
    }
    console.log('Child received loginMsg trigger:', newVal)
  }
},


methods:{

  getPopupData(val){
 this.$emit("updateformValue", val); 
  },
     validateEmail(email) {
      return /.+@.+\..+/.test(email);
    },
    sendToParent() {
      this.$emit("updateValue", 'popupTopDetails'); 
    },
loginForm() {
  console.log(this.loginDetails,'this.loginDetails')
    this.goLoader=true
      this.$emit("updateformValue", this.loginDetails); 
},
 getChildValue(val) {
      console.log(val,'0000')
       this.toggleView(val)
    },
    toggleView(value){
         this.registerFormDetail=false,
    this.loginFormDetail=false,
  
    this[value]=true
    }
},

 computed: {
 loginformValidation() {
      return (
        this.loginDetails.password !== "" &&
          this.validateEmail(this.loginDetails.email) &&
        this.loginDetails.email !== ""
      );
    },
 },
}

</script>

<style scoped>
@import "@/assets/formResponce.css";
>>>.v-field--center-affix .v-field__prepend-inner {
    padding-top: 12px !important;
}
>>>.v-text-field .v-field--no-label input, .v-text-field .v-field--active input {
    border: none !important;
   background: none !important;
       POSITION: relative !important;
    top: -7px !important;

}
>>>.postal-form .v-field__input {
    top: -2px !important;
}
>>>.v-input__control {
    display: flex;
    grid-area: control;
    height: 40px;
}
>>>.v-field--focused .v-field__prepend-inner, .v-field--focused .v-field__append-inner {
    opacity: 1;
    height: 40px !important;
}
>>>.v-field--center-affix .v-field__prepend-inner {
    align-items: center;
    padding-top: 0 !important;
    height: 40px;
}
@media screen and (max-width:660px) {
.v-field--focused .v-field__prepend-inner, .v-field--focused .v-field__append-inner {
    opacity: 1;
    height:40px !important;
}.v-field--center-affix .v-field__prepend-inner {
    align-items: center;
    padding-top: 0 !important;
    height: 40px;
}
}
</style>